import { isBoolean } from 'lodash'
import { LabeledValue } from '@commutifi-fe/ui'
import * as stateChangeTypes from './stateChangeTypes'

export interface VehicleStateProps {
  year?: number
  make?: string
  model?: LabeledValue
  engineType?: LabeledValue
  isUnknown: boolean
  isCustom: boolean
}
export default function vehicleReducer(
  state: VehicleStateProps,
  action: stateChangeTypes.VehicleActionTypes
): VehicleStateProps {
  let changes: Partial<VehicleStateProps>

  switch (action.type) {
    case stateChangeTypes.SelectYear: {
      changes = { year: action.payload.year, make: undefined, model: undefined, engineType: undefined }
      break
    }
    case stateChangeTypes.SelectMake: {
      changes = { make: action.payload.make, model: undefined, engineType: undefined }
      break
    }
    case stateChangeTypes.SelectModel: {
      changes = { model: action.payload.model, engineType: undefined }
      break
    }
    case stateChangeTypes.SelectEngineType: {
      changes = { engineType: action.payload.engineType }
      break
    }
    case stateChangeTypes.SetIsUnknown: {
      changes = { isUnknown: action.payload.isUnknown }
      break
    }
    case stateChangeTypes.ResetVehicle: {
      changes = { year: undefined, make: undefined, model: undefined, engineType: undefined }
      break
    }
    case stateChangeTypes.SetIsCustom: {
      changes = {
        isCustom: isBoolean(action.payload?.isCustom) ? action.payload?.isCustom : true
      }
      break
    }
    default:
      changes = {}
      break
  }
  return { ...state, ...changes }
}
